import { render, staticRenderFns } from "./ModalitaPartecipazione.vue?vue&type=template&id=2733fff4"
import script from "./ModalitaPartecipazione.vue?vue&type=script&lang=ts"
export * from "./ModalitaPartecipazione.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowDetailsTheAttachmentBtn: require('/usr/src/nuxt-app/components/show/details/TheAttachmentBtn.vue').default})
